import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinaryCareCreateAction from './veterinaryCareCreate.action.json' with { type: 'json' }
import { veterinaryCareObject } from '../veterinaryCareObject'
import { protocolObject } from '~/packages/general/protocol/protocolObject'

const veterinaryCareCreateDefinition = defineAction({
  ...veterinaryCareCreateAction,

  input: veterinaryCareObject
    .pick({
      serviceDate: true,
      veterinarianId: true,
      species: true,
      type: true,
    })
    .extend({
      id: veterinaryCareObject.shape.id.nullish(),
      citizenId: protocolObject.shape.citizenId.unwrap().unwrap(),
      residenceId: protocolObject.shape.residenceId.unwrap().unwrap(),
    }),
  output: z.object({
    id: veterinaryCareObject.shape.id,
    protocolId: protocolObject.shape.id,
    protocolCode: protocolObject.shape.code,
  }),
})

export default veterinaryCareCreateDefinition
